<template>
  <div class="row">
    <div class="col-sm-12">
      <h4 class="info-text ">
        {{ twoFaMessage }}
      </h4>

      <p class="f-size-14"></p>
    </div>

    <div class="col-sm-12">
      <div class="code-container">
        <input
          type="text"
          maxLength="6"
          autofocus
          size="6"
          min="0"
          max="9"
          pattern="[0-9]{1}"
          class="input-code"
          name="code"
          v-model.trim="code"
          :class="{ error: errors.has('step2.code') }"
          data-vv-scope="step2"
          v-validate="'required'"
        />
      </div>
    </div>
    <div class="col-sm-12 mt-3">
      <message-info />
    </div>
    <div class="col-sm-12 mt-3">
      <input
        type="button"
        class="btn btn-fill btn-success btn-block btn-wd btn-md"
        name="verify"
        value="Verify"
        @click.prevent="verifyCode()"
      />
    </div>

    <div class="col-sm-12 mt-3 text-center">
      <p>Didn't receive the code?</p>
      <a href="#" @click.prevent="sendCode()">Send code again</a><br />
    </div>
    <Loading v-if="loading" />
  </div>
</template>
<script>
var body = $("body");
function onKeyDown(e) {
  var key = e.which;
  if (
    key === 46 ||
    key === 37 ||
    key === 39 ||
    key === 8 ||
    key === 9 ||
    (key >= 48 && key <= 57) ||
    (key >= 96 && key <= 106)
  ) {
    return true;
  }

  e.preventDefault();
  return false;
}
body.on("keydown", ".input-code", onKeyDown);

import { mapGetters } from "vuex";
// import { Common } from "@/helper/common";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import Loading from "@/components/ui/Loading.vue";
import axios from "axios";
export default {
  name: "VerifyCode",
  props: ["token"],
  data() {
    return {
      code: "",
      loading: false,
      twoFaMessage:
        "Let's make sure it's really you. Please enter the code we've sent to your mobile ending in",
    };
  },
  computed: {
    ...mapGetters({
      currentActive: "getCurrentActive",
    }),
  },
  components: {
    "message-info": MessageInfo,
    Loading,
  },
  created() {
    //send 2fa code
    this.resetMessageInfo();
    this.sendCode();
  },
  methods: {
    resetMessageInfo() {
      this.$store.dispatch("setMessageInfo", {
        show: false,
        message: "",
        isSuccess: false,
      });
    },
    showGenericErrorMessage(message, success) {
      this.$store.dispatch("setMessageInfo", {
        show: true,
        message: message,
        isSuccess: success,
      });
    },
    async sendCode() {
      //send 2fa code to his mobile
      try {
        this.loading = true;
        const { data } = await axios.post(
          process.env.VUE_APP_SMT_API_URL + "/Client/GenerateAndSend2FA",
          null,
          {
            headers: {
              token: this.token,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        this.loading = false;
        this.twoFaMessage = "Let's make sure it's really you. " + data;
      } catch (ex) {
        this.loading = false;
        this.showGenericErrorMessage("We've encountered a problem.", false);
      }
    },
    verifyCode() {
      this.resetMessageInfo();
      this.$root.$validator.validate("step2.*").then(async (valid) => {
        if (valid) {
          //send code and next step??
          const result = await this.checkValidCode();
          console.log(result);
          if (result.success) {
            //this.goNextStep();
            this.$emit("verifiedTwoFa", result.token);
          } else {
            //not valid
            this.showGenericErrorMessage(
              "Please check the code you've entered and try again.",
              false
            );
          }
        } else {
          //not valid
          this.showGenericErrorMessage(
            "Please enter all mandatory fields.",
            false
          );
        }
      });
    },
    async checkValidCode() {
      this.loading = true;
      try {
        const { data } = await axios.get(
          process.env.VUE_APP_SMT_API_URL +
            "/Client/Verify2FA?code=" +
            parseInt(this.code),
          {
            headers: {
              token: this.token,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        this.loading = false;
        return { token: data.SingleObject, success: true };
      } catch (ex) {
        this.loading = false;
        this.showGenericErrorMessage(
          "Please check the code you've entered and try again.",
          false
        );
        return { token: "", success: false };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.code-container {
  display: flex;
}
.input-code {
  margin: 0 5px;
  text-align: center;
  line-height: 60px;
  font-size: 40px;
  border: solid 1px #ccc;
  box-shadow: 0 0 5px #ccc inset;
  outline: none;
  width: 100%;
  // width: 20%;
  transition: all 0.2s ease-in-out;
  border-radius: 3px;

  &:focus {
    border-color: purple;
    box-shadow: 0 0 5px purple inset;
  }

  &::selection {
    background: transparent;
  }
}
@media only screen and (max-width: 767.98px) {
  .input-code {
    line-height: 40px;
    font-size: 20px;
  }
}
</style>
